import React from 'react';
import classNames from 'classnames';

import { FxOrder, FxOrderStatus } from '../../../lib/models/reporting/types';
import { formatCurrencyBySymbol, getCurrencySymbolByCurrencyCode } from '../../../lib/util/DataHelpers';
import { parseDateTo, ParseToType } from '../../../lib/util/DateTimeHelpers';
import { isBuyEUR, isSellEUR } from '../../../lib/util/hooks/wallet/helpers';
import { TextHelpers } from '../../../lib/util/TextHelpers';

import IconBuyEuro from '../../../assets/img/icon_buy-eur.svg';
import IconSellEuro from '../../../assets/img/icon_sell-eur.svg';

import styles from './Transactions.module.scss';

type Props = {
    fxOrder: FxOrder
}
const FxOrderItem = ({ fxOrder }: Props) => (
  <div
    className={classNames(styles.wrapperOrder,
      {
        [styles.wrapperOrderCompleted]: fxOrder.orderStatus === FxOrderStatus.Fill,
      })}
  >
    <div className={styles.wrapperFirstHalf}>
      <img
        className={styles.icon}
        src={isSellEUR(fxOrder) ? IconSellEuro : IconBuyEuro}
        alt="icon arrow"
      />
      <div className={styles.orderInfo}>
        <div className={styles.orderSide}>
          {TextHelpers.getFxOrderStatusName(fxOrder)}
        </div>
        <div className={styles.fxDate}>
          {`${parseDateTo(new Date(fxOrder.fillDate), ParseToType.displayFormat)}`}
        </div>
      </div>
    </div>
    <div className={styles.fxOrderRow}>
      {
            isSellEUR(fxOrder)
              ? `${formatCurrencyBySymbol(fxOrder.soldAmountValue, getCurrencySymbolByCurrencyCode(fxOrder.soldAmountCurr))}`
              : `+${formatCurrencyBySymbol(fxOrder.boughtAmountValue, getCurrencySymbolByCurrencyCode(fxOrder.boughtAmountCurr))}`
        }
      <span>
        {
            isBuyEUR(fxOrder)
              ? `${formatCurrencyBySymbol(fxOrder.soldAmountValue, getCurrencySymbolByCurrencyCode(fxOrder.soldAmountCurr))}`
              : `+${formatCurrencyBySymbol(fxOrder.boughtAmountValue, getCurrencySymbolByCurrencyCode(fxOrder.boughtAmountCurr))}`
            }
      </span>
    </div>
  </div>
);
export default FxOrderItem;
